<template>
<div class="ts-app-shell_fh">
    <div class="padd-main">
      <div class="ts-app-shell--header">
        <h5>
          <strong>User's Interests Mapping</strong>
        </h5>
        <div class="ts-app-shell--header_actions flexed">          
        </div>
      </div>
      <span style="font-size: 14.4px;">
        Manage all your interest area in relation to apprenticeship program's expertise mapping. Select your desired activities, knowledge, skills, and essential skills for all available subject areas, levels, and pathways.
      </span>
    </div>
    <div class="ts-app-landing-dashboard">
      <div class="padd-main">
        <el-row :gutter="20">
          <el-col :span="24">
          </el-col>
        </el-row>
        <el-row :gutter="20">     
          <el-col :span="5" style="text-align:center">
            <el-card :body-style="{ padding: '0px' }" shadow="hover" >
              <div class="card-body" @click="viewCreateInterestArea">
                <h6 class="card-font">Create Area <br/> of Interests</h6>
                  <div class="dash-card">
                    <i class="fas fa-database"></i>
                  </div>                        
                  <div class="bottom clearfix">
                    <span slot="footer" class="ts-modal--footer">
                      <el-button class="ts-btn-small card-button">Create</el-button>
                    </span>
                  </div>
              </div>
            </el-card>
          </el-col>

          <el-col :span="15" :offset="1">
            <br>
            <h6 class="card-font">Create New Interest Area Mapping</h6> <br>
            <p>
                Start mapping your interests by specifying skills and knowledge for different subject areas, levels, and pathways.
            </p>
          </el-col> 
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="24">
          </el-col>
        </el-row>
        <el-row :gutter="20">     
          <el-col :span="5" style="text-align:center">
            <el-card :body-style="{ padding: '0px' }" shadow="hover" >
              <div class="card-body" @click="viewInterestArea">
                <h6 class="card-font">Manage <br/> Interest Area</h6>
                  <div class="dash-card">
                    <i class="fas fa-tasks"></i>
                  </div>                        
                  <div class="bottom clearfix">
                    <span slot="footer" class="ts-modal--footer">
                      <el-button class="ts-btn-small card-button">View</el-button>
                    </span>
                  </div>
              </div>
            </el-card>
          </el-col>

          <el-col :span="15" :offset="1">
            <br>
            <h6 class="card-font">Manage Your Interest Area Criteria</h6> <br>
            <p>
                Manage &amp; update your existing area of interest and make sure all the skills are up to date to get your dream apprenticeship program.
            </p>
          </el-col> 
        </el-row>
        </div>
    </div>

</div>
</template>

<script>

export default {
  created() {


  },
  computed: {

  },
  data() {
    return {

    };
  },
   methods: {
       viewCreateInterestArea(){
           this.$router.push({ path: '/interests/programcriteria' });
       },
       viewInterestArea(){
           this.$router.push({ name: 'ManageInterestCriteria' });
       },
   }
}
</script>
<style lang="scss">

</style>